import { $_bridge } from '@/nms/plugins/bridge.js'

// Определяем только минимальные типы
interface Book {
  id: string
  cls: string
  name: string
  $id: string
  children?: any[]
  childrenMeta?: { ui?: string; [key: string]: any }
  [key: string]: any
}

export default {
  state: () => ({
    books: [] as Book[],
    activeBookLibItem: null as string | null,
    activeBook: null as string | null,
    activeRecord: null as any | null,
    editRecord: null as any | null,
    bookObj: {} as Record<string, Book>,
    statuses: [] as any[],
  }),

  mutations: {
    LOAD_BOOKS(state: any, data: Book[]) {
      state.books = data
    },
    LOAD_BOOKS_LIBRARY(state: any, data: any) {
      state.bookLibrary = data
    },
    ACTIVE_BOOKS_LIB_ITEM(state: any, data: string | null) {
      state.activeBookLibItem = data
    },
    LOAD_BOOKOBJ(state: any, data: Book) {
      state.bookObj[data.name] = data
    },
    ACTIVE_BOOK(state: any, data: string | null) {
      state.activeBook = data
    },
    SET_STATUSES(state: any, data: any[]) {
      state.statuses = data
    },
    ACTIVE_RECORD(state: any, data: any | null) {
      state.activeRecord = data
    },
    EDIT_RECORD(state: any, data: any | null) {
      state.editRecord = data
    },
  },

  actions: {
    async loadBooks({ commit, state, dispatch }: any) {
        // console.log('loadBooks on store started')
        try {
          dispatch('setLoader', {
            key: 'loadBooks',
            value: true,
          })
          let query$ = {
            id: ['/catalogs'],
            // notNull: true,
            data: {
              namePath: true,
              links: {
                flatten: false,
                data: {
                  children: {
                    data: {
                      refs: true,
                    }
                  },
                  refs: true,
                }
              }
            }
          }
          let obj$ = await $_bridge.cmdbQuery(query$)
          let b = obj$[0]
          const books = b.links
          const booksMeta = await b.getChildrenMeta()
          console.log('STORE', 'loadBooks', 'books', books)
          // console.log('STORE', 'loadBooks', 'booksMeta', booksMeta)
          books.map(book => {
            commit('LOAD_BOOKOBJ', book)
            const bookMeta = booksMeta.find(item => {
              return item.$id == book.$id
            })
            if (bookMeta && bookMeta.childrenMeta && bookMeta.childrenMeta.length) {
              book.childrenMeta = bookMeta.childrenMeta[0]
            }
          })
          let filteredBooks = books
          commit('LOAD_BOOKS', filteredBooks)
          // commit('LOAD_BOOKS', books)
          dispatch('setLoader', {
            key: 'loadBooks',
            value: false,
          })
          if (!state.activeBook) {
            let filtered = books.filter(b => b.childrenMeta?.ui && b.childrenMeta?.ui == 'true')
            // console.log('STORE', 'loadBooks', 'filtered', filtered)
            commit('ACTIVE_BOOK', filtered[0].id)
          } 
          else {
            commit('ACTIVE_BOOK', state.activeBook)
          }
  
          let states$ = books.find(book => {
            return book.name == 'state'
          })
          if (states$ && states$.children) {
            console.log('STORE BOOKS STATES$', states$)
            commit('SET_STATUSES', states$.children)
          }
        } 
        catch (err) {
          console.error('CATCH', 'STORE', 'loadBooks', err)
          dispatch('setLoader', {
            key: 'loadBooks',
            value: false,
          })
        }
    },
    activeBook({ commit }: any, data: string | null) {
      commit('ACTIVE_BOOK', data)
    },
    activeBookLib({ commit }: any, data: string | null) {
      commit('ACTIVE_BOOKS_LIB_ITEM', data)
    },
    activeRecord({ commit }: any, data: any | null) {
      commit('ACTIVE_RECORD', data)
    },
    editRecord({ commit }: any, data: any | null) {
      commit('EDIT_RECORD', data)
    },
  },

  getters: {
    editRecord: (state: any) => state.editRecord,
    getBooks: (state: any) => state.books,
    getActiveLibBook: (state: any) => state.activeBookLibItem,
  },
}